<template>
  <AppsAboutClip />
</template>

<script setup>
import { useLockScrollServiceAbout } from "~/composables/useLockScrollServiceAbout";
// Services
useLockScrollServiceAbout();
</script>

<style lang="scss" scoped></style>